import { OptionPropType } from '@scholastic/volume-react';

export interface InstitutionListOptions extends OptionPropType {
  group: string;
}

export interface GroupOptions {
  label: string;
  value: string;
}

export const transformInstitutionList = (list: InstitutionListOptions) => {
  return Object.entries(list)
    .map((entry) => ({
      label: entry[1].customername,
      group: entry[1].groupcode,
      value: entry[0],
    }))
    .sort((a, b) => (a.label < b.label ? -1 : Number(a.label > b.label)));
};

export const transformGroups = (apiGroupData: string[]): GroupOptions[] => {
  let groupList = apiGroupData.map((groupItem: string) => {
    return { label: groupItem, value: groupItem };
  });
  groupList.unshift({
    label: 'Show All',
    value: '',
  });

  return groupList;
};
